<template>
	<aside class="iv2-extra-nav theme-a__extra-bg position-fixed text-center d-xl-block">
		<nav class="iv2-extra-nav__sub-menu">
			<ul class="iv2-extra-nav__sub-list list-unstyled">
				<li v-for="nav in extra" :key="nav.id" class="iv2-extra-nav__sub-item">
					<router-link
						v-if="nav.link_type == 'internal'"
						:to="nav.link_href"
						@click.native="activeMenu = false"
						class="iv2-extra-nav__sub-link theme-a__extra-link"
					>
						<i class="iv2-extra-nav__sub-item-icon d-block" :class="nav.item_icon"></i>
						<span class="iv2-extra-nav__sub-item-text d-block">{{nav.item_name}}</span>
					</router-link>
					<a
						v-else-if="nav.link_type == 'external'"
						v-bind:href="nav.link_href"
						:target="nav.target_type"
						rel="noopener"
						class="iv2-extra-nav__sub-link theme-a__extra-link"
					>
						<i class="iv2-extra-nav__sub-item-icon d-block" :class="nav.item_icon"></i>
						<span class="iv2-extra-nav__sub-item-text d-block">{{nav.item_name}}</span>
					</a>
				</li>
			</ul>
		</nav>
	</aside>
</template>

<script>
export default {
	props: ["extra"],
};
</script>

<style lang="scss">
.iv2-extra-nav {
	padding: 20px 0;

	.iv2-extra-nav__sub-menu {
		.iv2-extra-nav__sub-list {
			.iv2-extra-nav__sub-item {
				margin-bottom: 16px;
				width: 64px;

				&:last-child {
					margin-bottom: 0;
				}

				.iv2-extra-nav__sub-link {
					-webkit-transition: 0.3s;
					transition: 0.3s;

					&:hover {
						text-decoration: none;
						opacity: 0.5;
					}
				}

				.iv2-extra-nav__sub-item-icon {
					font-size: 1.2rem;
					margin-bottom: 10px;
				}

				.iv2-extra-nav__sub-item-text {
					font-size: 10px;
					font-weight: 400;
					line-height: 1.3;
				}
			}
		}
	}
}
</style>